import React, { useEffect, useState } from 'react';
import './membershipStatus.css';
import Select from 'react-select';
import { Button } from '@chakra-ui/react';
import Papa from 'papaparse';

// TODO: connect these service stubs to your real API implementation

// import {
//   obtenerResumenActividad,
//   obtenerReservaciones,
//   obtenerReservacionesAmenidades,
// } from '../services/membresia';

import EstadoCuenta from './estadoCuenta'; // existing component
import { formatToMXN } from '../util/util';
import { useNavigate, useParams } from 'react-router';
import { getActividadMembresiaByTitular, getDaypassByDateAdmin } from '../../services/daypass';
import obtenerReservaciones from '../../services/obtenerReservaciones';
import Pagination from '../util/pagination/pagination';


const MembershipStatus = () => {
  /* ─────────────────────────── STATE */
  const [tab, setTab] = useState('activity');

  const { id } = useParams();

  const navigate = useNavigate()

  // Activity summary metrics
  const [activity, setActivity] = useState(null);

  // Reservation filters & data
  const [resStart, setResStart] = useState('');
  const [resEnd, setResEnd] = useState('');
  const [reservationType, setReservationType] = useState(null);
  const [reservations, setReservations] = useState([]);
  const [resPage, setResPage] = useState(1);
  const [resPageTotal, setResPageTotal] = useState(1);

  // Amenity filters & data
  const [amenityDateStart, setAmenityDateStart] = useState('');
  const [amenityDateEnd, setAmenityDateEnd] = useState('');
  const [amenityReservations, setAmenityReservations] = useState([]);
  const [amenityPage, setAmenityPage] = useState(1);
  const [amenityPageTotal, setAmenityPageTotal] = useState(1);

  const [loading, setLoading] = useState(true);

  /* ─────────────────────────── EFFECTS */
  useEffect(() => {
    // fetch activity summary on mount / membership change
    // obtenerResumenActividad(membershipId).then((r) => setActivity(r.data));
  }, [id]);

  /* ─────────────────────────── HELPERS */
  /**
   * Generic helper for triggering file exports (PDF/XLSX/CSV)
   * @param {string} url – fully qualified endpoint to hit
   */

  const loadReservations = () => {
    // obtenerReservaciones({
    //   membershipId,
    //   start: resStart,
    //   end: resEnd,
    //   type: reservationType?.value,
    // }).then((r) => setReservations(r.data));
  };

  const loadAmenityReservations = () => {
    // obtenerReservacionesAmenidades({ membershipId, date: amenityDate }).then(
    //   (r) => setAmenityReservations(r.data)
    // );
  };

  const requestActividadMembresia = async () => {
    try {
      const response = await getActividadMembresiaByTitular(id);

      setActivity(response.data);



    } catch (error) {
      console.error('Error fetching activity summary:', error);
      // Handle error appropriately (e.g., show a notification)
    }
  }

  const downloadActivityAsCSV = () => {
    if (!activity) {
        console.error("No activity data available to export.");
        return;
    }

    // Prepare the data for CSV
    const csvData = [
        { label: "Nombre del titular", value: `${activity.titular.nombre} ${activity.titular.apellidos}` },
        { label: "Correo del titular", value: activity.titular.correo },
        { label: "No. de Membresía", value: activity.titular.membresia },
        { label: "Noches Propias Disponibles", value: 
            (activity.numeroNoches ? activity.numeroNoches : 0) + 
            (activity.nochesAlta ? activity.nochesAlta : 0)
        },
        { label: "Noches Adicionales Reservadas", value: activity.countDiasReservadosTemporadaAlta },
        { label: "Noches Liberadas al Pool de Rentas", value: 
            (
                activity.totalNochesLiberadas && activity.totalNochesLiberadas.nochesAlta ?
                activity.totalNochesLiberadas.nochesAlta : 0
            ) +
            (
                activity.totalNochesLiberadas && activity.totalNochesLiberadas.nochesBaja ?
                activity.totalNochesLiberadas.nochesBaja : 0
            )
        },
        { label: "Noches Vendidas", value: activity.cuentapropiacount },
    ];

    // Convert the data to CSV format using PapaParse
    const csv = Papa.unparse({
        fields: ["label", "value"], // Define the column headers
        data: csvData.map(row => [row.label, row.value]), // Map the data to rows
    });

    // Create a Blob and trigger the download
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "ActivitySummary.csv"; // Set the file name
    document.body.appendChild(link);
    link.click();
    link.remove();
};

  const requestDayPass = async () => {
    if(!id ) {
      console.warn('Missing ID for Day Pass request');
      return;
    }
    try {
      const response = await getDaypassByDateAdmin(
        null,
        amenityDateStart,
        amenityDateEnd,
        id,
        amenityPage
      )
      setAmenityReservations(response.data.reservas ? response.data.reservas : []);
      setAmenityPageTotal(response.data.totalPages ? response.data.totalPages : 1);
    } catch (error) {
      console.error('Error fetching Day Pass data:', error);
      // Handle error appropriately (e.g., show a notification)
    }
  }

  const requestAllDayPass = async () => {
    if(!id){
      console.warn('Missing ID for Day Pass request');
      return;
    }
    const response = await getDaypassByDateAdmin(
      null,
      amenityDateStart,
      amenityDateEnd,
      id
    );
    return response;
  }

  const downloadAmenityReservationsAsCSV = async () => {
    try {
        // Fetch all amenity reservations using the requestAllDayPass function
        const response = await requestAllDayPass();

        if (!response || !response.data || !response.data.reservas) {
            console.error("No amenity reservation data available to export.");
            return;
        }

        // Prepare the data for CSV
        const csvData = response.data.reservas.map((reservation) => ({
            Nombre: `${activity.titular.nombre} ${activity.titular.apellidos}`, // Assuming activity contains titular info
            Membresía: activity.titular.membresia, // Assuming activity contains membership info
            Fecha: new Date(reservation.fechaReservada).toLocaleDateString(), // Format date as DD/MM/YYYY
            "Número de personas": reservation.numPersonas,
        }));

        // Convert the data to CSV format using PapaParse
        const csv = Papa.unparse({
            fields: ["Nombre", "Membresía", "Fecha", "Número de personas"], // Define the column headers
            data: csvData.map((row) => Object.values(row)), // Map the data to rows
        });

        // Create a Blob and trigger the download
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "AmenityReservations.csv"; // Set the file name
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error("Error exporting amenity reservations:", error);
    }
};

  const requestReservaciones = async () => {
    if(!id){
      console.warn('Missing ID for Reservaciones request');
      return;
    }

    try {
      const response = await obtenerReservaciones(
        id,
        !(resStart && resEnd),
        resStart,
        resEnd,
        reservationType ? reservationType.value : null,
        resPage
      )

      setReservations(response.data.reservaciones ? response.data.reservaciones : []);
      setResPageTotal(response.data.totalPages ? response.data.totalPages : 1);

    }catch (error) {
      console.error('Error fetching reservations:', error);
      // Handle error appropriately (e.g., show a notification)
    }
  }

  const requestAllReservaciones = async () => {
    if(!id){
      console.warn('Missing ID for Reservaciones request');
      return;
    }
    const response = await obtenerReservaciones(
      id,
      true,
      resStart,
      resEnd,
      reservationType ? reservationType.value : null
    );
    return response
  }

  const downloadReservationsAsCSV = async () => {
    try {
        // Fetch all reservations using the requestAllReservaciones function
        const response = await requestAllReservaciones();

        if (!response || !response.data || !response.data.reservaciones) {
            console.error("No reservation data available to export.");
            return;
        }

        // Prepare the data for CSV
        const csvData = response.data.reservaciones.map((reservation) => ({
            Nombre: reservation.nombreTitular,
            Token: reservation.token, // Assuming token is a field in the reservation object
            Membresia: activity.titular.membresia, // Assuming activity is already fetched and contains the titular info
            "Fecha Llegada": reservation.fechaLlegada.split("T")[0], // Format date as YYYY-MM-DD
            "Fecha Salida": reservation.fechaSalida.split("T")[0], // Format date as YYYY-MM-DD
            Tipo: reservation.tipoReservacion,
            Cabaña: reservation.tipoCabana,
        }));

        // Convert the data to CSV format using PapaParse
        const csv = Papa.unparse({
            fields: ["Nombre", "Token", "Membresia", "Fecha Llegada", "Fecha Salida", "Tipo", "Cabaña"], // Define the column headers
            data: csvData.map((row) => Object.values(row)), // Map the data to rows
        });

        // Create a Blob and trigger the download
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Reservations.csv"; // Set the file name
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error("Error exporting reservations:", error);
    }
  };

  useEffect(() => {
    requestReservaciones();
  }, [resPage])

  useEffect(() => {
    if(resPage == 1){
      requestReservaciones();
    }else{
      setResPage(1);
    }
  }, [resStart, resEnd, reservationType, id]);

  useEffect(() => {
    requestActividadMembresia();
  }, [])

  useEffect(() => {
    requestDayPass();
  }, [amenityPage])

  useEffect(() => {
    if(amenityPage === 1){
      requestDayPass();
    }else{
      setAmenityPage(1);
    }
  }, [amenityDateStart, amenityDateEnd, id]);

  /* ─────────────────────────── RENDER */
  return (
    <div className="container">
      {/* TAB NAVIGATION */}
      <div className="tabs">
        <button
          className={`tab ${tab === 'activity' ? 'active' : ''}`}
          onClick={() => setTab('activity')}
        >
          Resumen
        </button>
        <button
          className={`tab ${tab === 'account' ? 'active' : ''}`}
          onClick={() => setTab('account')}
        >
          Estado de Cuenta
        </button>
        <button
          className={`tab ${tab === 'reservations' ? 'active' : ''}`}
          onClick={() => setTab('reservations')}
        >
          Reservaciones
        </button>
        <button
          className={`tab ${tab === 'amenities' ? 'active' : ''}`}
          onClick={() => setTab('amenities')}
        >
          Amenidades
        </button>
        <button
          className={`tab ${tab === 'accounting' ? 'active' : ''}`}
          onClick={() => setTab('accounting')}
        >
          Contabilidad
        </button>
      </div>

      {/* ─────────────────────────── TAB 1: ACTIVITY SUMMARY */}
      {tab === 'activity' && (
        <div className="tab-content active">
          <h3 className="section-header">Resumen de Actividad de la Membresía</h3>
          {!activity ? (
            <p>Cargando…</p>
          ) : (
            <div className="account-info">
              <div className="info-row">
                <div className="info-label">
                  Nombre del titular
                </div>
                <div className="info-value">
                  {
                    `${activity.titular.nombre} ${activity.titular.apellidos}`
                  }
                </div>
              </div>
              <div className="info-row">
                <div className="info-label">
                  Correo del titular
                </div>
                <div className="info-value">
                  {
                    activity.titular.correo
                  }
                </div>
              </div>
              <div className="info-row">
                <div className="info-label">
                  No. de Membresía
                </div>
                <div className="info-value">
                  {
                    activity.titular.membresia
                  }
                </div>
              </div>
              <div className="info-row">
                <div className="info-label">Noches Propias Disponibles</div>
                <div className="info-value">
                  {
                    (activity.numeroNoches ? activity.numeroNoches : 0) + 
                    (activity.nochesAlta ? activity.nochesAlta : 0)
                  }
                </div>
              </div>
              <div className="info-row">
                <div className="info-label">Noches Adicionales Reservadas</div>
                <div className="info-value">{activity.countDiasReservadosTemporadaAlta}</div>
              </div>
              <div className="info-row">
                <div className="info-label">Noches Liberadas al Pool de Rentas</div>
                <div className="info-value">
                  {
                    (
                      activity.totalNochesLiberadas && activity.totalNochesLiberadas.nochesAlta ?
                      activity.totalNochesLiberadas.nochesAlta : 0
                    )
                    +
                    (
                      activity.totalNochesLiberadas && activity.totalNochesLiberadas.nochesBaja ?
                      activity.totalNochesLiberadas.nochesBaja : 0
                    )
                  }
                </div>
              </div>
              <div className="info-row">
                <div className="info-label">Noches Vendidas</div>
                <div className="info-value">{activity.cuentapropiacount}</div>
              </div>
            </div>
          )}

          <div className="action-row">
            {/*
              NOTE: export endpoints must be implemented on back‑end.
              Example routes are provided here for convenience.
            */}
            {/* <Button
              className="btn"
              //onClick={() => handleExport(`/api/membresia/${membershipId}/activity/pdf`)}
            >
              Descargar PDF
            </Button> */}
            <Button
              className="btn"
              backgroundColor={'#e06c00'}
              color={'white'}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#d65f00')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#e06c00')}
              onClick={downloadActivityAsCSV}
            >
              Descargar CSV
            </Button>
          </div>
        </div>
      )}

      {/* ─────────────────────────── TAB 2: ACCOUNT STATEMENT */}
      {tab === 'account' && (
        <div className="tab-content active">
          {/* EstadoCuenta already contains its own export buttons */}
          <EstadoCuenta titularID={id} />
        </div>
      )}

      {/* ─────────────────────────── TAB 3: RESERVATIONS */}
      {tab === 'reservations' && (
        <div className="tab-content active">
          <h3 className="section-header">
            Reservaciones
          </h3>

          {/* Filters */}
          <div className="filter-row">
            <div className="filter-group">
              <label className="filter-label">Inicio:</label>
              <input
                type="date"
                value={resStart}
                onChange={(e) => setResStart(e.target.value)}
              />
            </div>
            <div className="filter-group">
              <label className="filter-label">Fin:</label>
              <input
                type="date"
                value={resEnd}
                onChange={(e) => setResEnd(e.target.value)}
              />
            </div>
            <div className="filter-group">
              <Select
                placeholder="Tipo de reservación"
                options={[
                  { value: 'TITULAR', label: 'Titular' },
                  { value: 'CORTESIA', label: 'Cortesía' },
                  { value: 'OTRACABANA', label: 'Otra Cabaña' },
                  { value: 'CUENTAPROPIA', label: 'Cuenta Propia' },
                ]}
                value={reservationType}
                onChange={setReservationType}
                className="select"
                isClearable={true}
              />
            </div>
          </div>

          {/* Table */}
          <table className="account-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Membresía</th>
                <th>Token</th>
                <th>Fecha Llegada</th>
                <th>Fecha Salida</th>
                <th>Tipo</th>
                <th>Cabaña</th>
              </tr>
            </thead>
            <tbody>
              {reservations.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center' }}>
                    Sin datos
                  </td>
                </tr>
              ) : (
                reservations.map((r) => (
                  <tr key={r.id}>
                    <td>{r.nombreTitular}</td>
                    <td>{activity.titular.membresia}</td>
                    <td>{r.token}</td>
                    <td>{r.fechaLlegada.split('T')[0]}</td>
                    <td>{r.fechaSalida.split('T')[0]}</td>
                    <td>{r.tipoReservacion}</td>
                    <td>{r.tipoCabana}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <Pagination
            currentPage={resPage}
            pageCount={resPageTotal}
            onPageChange={(page) => setResPage(page)}
          />
          <div className="action-row">
            <Button
              className="btn"
              backgroundColor={'#e06c00'}
              color={'white'}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#d65f00')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#e06c00')}
              onClick={downloadReservationsAsCSV}
            >
              Descargar CSV
            </Button>
          </div>
        </div>
      )}

      {/* ─────────────────────────── TAB 4: AMENITY RESERVATIONS */}
      {tab === 'amenities' && (
        <div className="tab-content active">
          <h3 className="section-header">Reservaciones de Amenidades</h3>

          {/* Filters */}
          <div className="filter-row">
            <div className="filter-group">
              <label className="filter-label">Fecha de Inicio:</label>
              <input
                type="date"
                value={amenityDateStart}
                onChange={(e) => setAmenityDateStart(e.target.value)}
              />
            </div>
            <div className="filter-group">
              <label className="filter-label">Fecha de Fin:</label>
              <input
                type="date"
                value={amenityDateEnd}
                onChange={(e) => setAmenityDateEnd(e.target.value)}
              />
            </div>
          </div>

          {/* Table */}
          <table className="account-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Membresía</th>
                <th>Fecha</th>
                <th>Número de personas</th>
              </tr>
            </thead>
            <tbody>
              {amenityReservations.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center' }}>
                    Sin datos
                  </td>
                </tr>
              ) : (
                amenityReservations.map((r) => (
                  <tr key={r.id}>
                    <td>{`${activity.titular.nombre} ${activity.titular.apellidos}`}</td>
                    <td>{activity.titular.membresia}</td>
                    <td>{new Date(r.fechaReservada).toLocaleDateString()}</td>
                    <td>{r.numPersonas}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <Pagination
            currentPage={amenityPage}
            pageCount={amenityPageTotal}
            onPageChange={(page) => setAmenityPage(page)}
          />
          <div className="action-row">
            <Button
              className="btn"
              backgroundColor={'#e06c00'}
              color={'white'}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#d65f00')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#e06c00')}
              onClick={downloadAmenityReservationsAsCSV}
            >
              Descargar CSV
            </Button>
          </div>
        </div>
      )}

      {/* ─────────────────────────── TAB 5: ACCOUNTING */}
      {tab === 'accounting' && (
        <div className="tab-content active">
          <h3 className="section-header">Contabilidad</h3>
          <p>
            Gestiona los movimientos financieros asociados a esta membresía.
          </p>
          <Button
            backgroundColor={'#e06c00'}
            color={'white'}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#d65f00')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#e06c00')}
            onClick={() => navigate(`/finanzas`)}
            // onClick={() => (window.location.href = `/contabilidad/${membershipId}`)}
          >
            Acceder al Módulo de Contabilidad
          </Button>
        </div>
      )}
    </div>
  );
};

export default MembershipStatus;
